module.exports = __webpack_public_path__ + "img/heavy_pin_attention.169d1e29.svg";